import AboutPage from '../../pages/About';
import CartePage from '../../pages/Carte';
import CompteUtilisateurPage from '../../pages/CompteUtilisateur';
import Home from '../../pages/Home';
import JournalisationPage from '../../pages/Journalisation';
import LogPage from '../../pages/Log';
import Paiement from '../../pages/Paiement';
import PermissionPage from '../../pages/Permission';
import PointOfSaleMasterDataPage from '../../pages/PointOfSaleMasterData';
import PriseCarburant from '../../pages/PriseCarburant';
import PrixPage from '../../pages/Prix';
import LivraisonCarteReport from '../../pages/report/LivraisonCarte';
import ReleveClientReport from '../../pages/report/ReleveClient';
import SoldeClientPage from '../../pages/SoldeClient';
import { AllRoutes } from './allRoutes';
import { PermissionType } from './permissionType';
import { Resource } from './portailResource';

interface SubRoute {
    path: string;
    requiredPermission: PermissionType;
}

export interface ProtectedRoute {
    path: AllRoutes;
    component: React.ComponentType<any>;
    resource: Resource;
    requiredPermission: PermissionType;
    subRoutes?: SubRoute[];
}

export const protectedRoutes: ProtectedRoute[] = [
    {
        path: AllRoutes.HOME,
        component: Home,
        resource: Resource.HOME,
        requiredPermission: PermissionType.LECTURE,
    },
    {
        path: AllRoutes.PRISE_CARBURANT,
        component: PriseCarburant,
        resource: Resource.PRISE_CARBURANT,
        requiredPermission: PermissionType.LECTURE,
    },
    {
        path: AllRoutes.PAIEMENT,
        component: Paiement,
        resource: Resource.PAIEMENT,
        requiredPermission: PermissionType.LECTURE,
    },
    {
        path: AllRoutes.CARTE,
        component: CartePage,
        resource: Resource.CARTE,
        requiredPermission: PermissionType.LECTURE,
        subRoutes: [
            {
                path: 'create',
                requiredPermission: PermissionType.CREATION,
            },
        ],
    },
    {
        path: AllRoutes.COMPTE_UTILISATEUR,
        component: CompteUtilisateurPage,
        resource: Resource.COMPTE_UTILISATEUR,
        requiredPermission: PermissionType.LECTURE,
    },
    {
        path: AllRoutes.POINT_OF_SALE_MASTER_DATA,
        component: PointOfSaleMasterDataPage,
        resource: Resource.POINT_OF_SALE_MASTER_DATA,
        requiredPermission: PermissionType.LECTURE,
    },
    {
        path: AllRoutes.PRIX,
        component: PrixPage,
        resource: Resource.PRIX,
        requiredPermission: PermissionType.LECTURE,
    },
    {
        path: AllRoutes.JOURNALISATION,
        component: JournalisationPage,
        resource: Resource.JOURNALISATION,
        requiredPermission: PermissionType.LECTURE,
    },
    {
        path: AllRoutes.LOG,
        component: LogPage,
        resource: Resource.LOG,
        requiredPermission: PermissionType.LECTURE,
    },
    {
        path: AllRoutes.CLIENT,
        component: SoldeClientPage,
        resource: Resource.OCRD,
        requiredPermission: PermissionType.LECTURE,
    },
    {
        path: AllRoutes.PERMISSION,
        component: PermissionPage,
        resource: Resource.ROLE_RESSOURCE_PORTAIL,
        requiredPermission: PermissionType.LECTURE,
    },
    {
        path: AllRoutes.ABOUT,
        component: AboutPage,
        resource: Resource.ABOUT,
        requiredPermission: PermissionType.LECTURE,
    },
    {
        path: AllRoutes.RELEVE_CLIENT,
        component: ReleveClientReport,
        resource: Resource.RELEVE_CLIENT,
        requiredPermission: PermissionType.LECTURE,
    },
    {
        path: AllRoutes.LIVRAISON_CARTE_REPORT,
        component: LivraisonCarteReport,
        resource: Resource.LIVRAISON_CARTE_REPORT,
        requiredPermission: PermissionType.LECTURE,
    },

    // utilities ===

    // {
    //     path: AllRoutes.LOCKED_CARDS_UTILITY,
    //     component: LockedCartePage,
    //     resource: Resource.CARTE,
    //     requiredPermission: PermissionType.LECTURE,
    // },
];
